const palette = {
  darkGrey: "#121212",
  grey200: "#282828",
  red200: "#EF9A9A",
  red300: "#FF6859",
  green200: "#A5D6A7",
  green300: "#81C784",
  blue200: "#90CAF9",
  blue300: "#72DEFF",
  yellow200: "#FFF59D",
  yellow300: "#FFCF44",
};

const colors = {
  background: palette.grey200,
  surface00: "rgba(255, 255, 255, 0)",
  surface01: "rgba(255, 255, 255, .05)",
  surface02: palette.grey200,
  surface04: "rgba(255, 255, 255, .09)",
  textHigh: "rgba(255, 255, 255, .87)",
  textMed: "rgba(255, 255, 255, .6)",
  textLow: "rgba(255, 255, 255, .38)",
  textLow2: "rgba(255, 255, 255, .2)",
  textLow3: "rgba(255, 255, 255, .12)",
  red: palette.red300,
  green: palette.green300,
  blue: palette.blue300,
  yellow: palette.yellow300,
  bottomSheetBackground: "rgba(47, 47, 47, 1)",
  sideSheetBackground: "rgba(47, 47, 47, 1)",
  circleOverlayStroke: "rgba(255, 0, 0, 0.6)",
  circleOverlayFill: "rgba(255, 0, 0, 0.3)",
  circleOverlayFillSelected: "rgba(255, 0, 0, 0.6)",
};

export default colors;
